import CheckIcon from "@mui/icons-material/Check";
import {
  Box,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem
} from "@mui/material";
import { useEffect, useState } from "react";

import { createTheme, ThemeProvider } from "@mui/material/styles";

const targetToggleTheme = createTheme({
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: {
          width: 36,
          height: 36,
          borderRadius: 8,
          transition: "all 0.15s ease",
          border: "1px solid #D1D4DA",
          "&.Mui-active": {
            backgroundColor: "#627CFB14",
            borderColor: "#97B1FF",
          },

          "&:hover": {
            backgroundColor: "#627CFB14",
            borderColor: "#97B1FF",
          },

          "&.Mui-focusVisible": {
            backgroundColor: "#627CFB14",
            borderColor: "#97B1FF",
          },
        },
      },
    },

    MuiMenu: {
      styleOverrides: {
        paper: {
          marginTop: 4,
          borderRadius: 8,
          minWidth: 180,
        },
      },
    },

    MuiMenuItem: {
      styleOverrides: {
        root: {
          "&.Mui-selected, &:hover": {
            color: "#627CFB",
          },
          transition: "all 0.15s ease",
        },
      },
    },

    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: "#627CFB",
        },
      },
    },
  },
});

export default function TargetTypeToggle() {
  const [anchorEl, setAnchorEl] = useState(null);
  const [targetType, setTargetType] = useState(() => {
    const stored = localStorage.getItem("isCustomTarget");
    return stored === "true" ? "custom" : "default";
  });
  const [isHovered, setIsHovered] = useState(false);
  const open = Boolean(anchorEl);

  useEffect(() => {
    const isCustom = targetType === "custom";

    localStorage.setItem("isCustomTarget", JSON.stringify(isCustom));

    const event = new CustomEvent("targetTypeChanged", {
      detail: isCustom,
    });
    window.dispatchEvent(event);
  }, [targetType]);

  return (
    <ThemeProvider theme={targetToggleTheme}>
      <>
        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          className={open ? "Mui-active" : ""}
          sx={{ p: "5px" }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <Box
            component="img"
            src={
              open || isHovered
                ? "/blue-target-toggle.svg"
                : "/target-toggle.svg"
            }
            alt="Target toggle"
            sx={{
              width: 30,
              height: 30,
              transition: "filter 0.15s ease",
            }}
          />
        </IconButton>

        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <MenuItem
            selected={targetType === "default"}
            onClick={() => setTargetType("default")}
            sx={{
              backgroundColor: "transparent",
              "&:hover": { backgroundColor: "transparent" },
              "&.Mui-selected": { backgroundColor: "transparent" },
            }}
          >
            <ListItemIcon>
              {targetType === "default" && (
                <CheckIcon sx={{ color: "#627CFB" }} fontSize="small" />
              )}
            </ListItemIcon>
            <ListItemText primary="Default Targets" />
          </MenuItem>
          <MenuItem
            selected={targetType === "custom"}
            onClick={() => setTargetType("custom")}
            sx={{
              backgroundColor: "transparent",
              "&:hover": { backgroundColor: "transparent" },
              "&.Mui-selected": { backgroundColor: "transparent" },
            }}
          >
            <ListItemIcon>
              {targetType === "custom" && (
                <CheckIcon sx={{ color: "#627CFB" }} fontSize="small" />
              )}
            </ListItemIcon>
            <ListItemText primary="Custom Targets" />
          </MenuItem>
        </Menu>
      </>
    </ThemeProvider>
  );
}
